import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';

// Used only by the plans and participation pages; hashes stay the same in both languages.
export default function PageDetailsAccordion({ panels }) {
  const location = useLocation();
  const [open, setOpen] = useState([]);
  const triggers = useRef({});
  const targets = panels.map(({ id, aliases = [] }) => [id, ...aliases].join(':')).join('|');

  useEffect(() => {
    let hash;
    try { hash = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    const target = targets.split('|').map(group => group.split(':')).find(ids => ids.includes(hash));
    if (!hash || !target) return;
    const id = target[0];
    setOpen(current => current.includes(id) ? current : [...current, id]);
    // Wait for the panel to open and for the application's general hash scroll.
    let secondFrame;
    const firstFrame = requestAnimationFrame(() => {
      secondFrame = requestAnimationFrame(() => {
        const trigger = triggers.current[id];
        if (!trigger) return;
        const headerHeight = document.querySelector('header')?.getBoundingClientRect().height || 0;
        trigger.style.scrollMarginTop = `${headerHeight + 16}px`;
        trigger.focus({ preventScroll: true });
        trigger.scrollIntoView({ block: 'start', behavior: 'instant' });
      });
    });
    return () => { cancelAnimationFrame(firstFrame); cancelAnimationFrame(secondFrame); };
  }, [location.hash, location.key, targets]);

  return <Accordion type="multiple" value={open} onValueChange={setOpen} className="min-w-0 rounded-md border border-[#E2DACB] bg-[#FFFDF8] px-4 sm:px-5">
    {panels.map(({ id, title, children }) => <AccordionItem key={id} value={id} className="last:border-b-0">
      <AccordionTrigger id={id} ref={node => { triggers.current[id] = node; }} className="gap-4 text-base text-[#2A2521] transition-none [&>svg]:transition-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#557448]">
        {title}
      </AccordionTrigger>
      <AccordionContent aria-labelledby={id} style={{ animation: 'none' }} className="space-y-3 text-base leading-relaxed text-[#4A443D]">
        {children}
      </AccordionContent>
    </AccordionItem>)}
  </Accordion>;
}
